import React from 'react'
import {Helmet} from 'react-helmet'
import {Container, Row, Col} from 'reactstrap'
import {format} from 'date-fns'
import {isEmpty} from 'lodash-es'

// Components
import BD from './BlogDetails.styled'
import Slider from '~/components/Slider'
import Share from '~/components/Share'
import SearchBar from '../list/Search'
import LatestBlogList from './LatestBlogList'
import RecentProperties from './RecentProperties'

// Utils
import {renderHtml, enhancedGet} from '~/utils'

const BlodDetailsComponent = (props) => {
  const {
    fullUrl,
    blog,
    recentProperties,
    latestBlogList,
  } = props

  if (isEmpty(blog)) {
    return null
  }

  const {
    title = '',
    thumbnail = {},
    gallery = [],
    content = {},
    seoKeywords = '',
    seoDescription = '',
    tags = [],
    createdAt,
  } = blog

  const date = format(new Date(createdAt), 'dd/MM/yyyy')

  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta name='keywords' content={seoKeywords} />

        <meta name='description' content={seoDescription} />
      </Helmet>

      <BD>
        <BD.Header thumbnail={enhancedGet(thumbnail, 'url', '')}>
          <BD.HeaderInner>
            <BD.Date>{date}</BD.Date>

            <BD.Title>{title}</BD.Title>
          </BD.HeaderInner>
        </BD.Header>

        <Container>
          <BD.MainContainer>
            <Row>
              <Col md={9}>
                <BD.LeftContent>
                  <BD.SliderWrapper>
                    <Slider images={gallery} />
                  </BD.SliderWrapper>

                  <BD.Content>{renderHtml(content)}</BD.Content>

                  <BD.Footer>
                    <BD.Tags>
                      {tags.map((tag) => <BD.TagItem key={tag.name}>{tag.name}</BD.TagItem>)}
                    </BD.Tags>

                    <Share url={fullUrl} media={enhancedGet(thumbnail, 'url', '')} />
                  </BD.Footer>
                </BD.LeftContent>
              </Col>

              <Col md={3}>
                <SearchBar />

                <LatestBlogList list={latestBlogList} />

                <RecentProperties list={recentProperties} />
              </Col>
            </Row>
          </BD.MainContainer>
        </Container>
      </BD>
    </>
  )
}

export default BlodDetailsComponent
